import { z } from 'zod'
import { referenciaFamiliarArray } from 'types/familiar-reference-v2.type'

export const SocioeducationMeasureFamilyDataSchema = z.object({
  id: z.number().nullish(),
  referenciasFamiliares: referenciaFamiliarArray,
  outrasReferenciasFamiliares: referenciaFamiliarArray,
  descricaoRelacoesFamiliares: z.string().nullish(),
})

export type SocioeducationMeasureFamilyDataType = z.infer<
  typeof SocioeducationMeasureFamilyDataSchema
>

export const SocioeducationMeasureFamilyDataDefaultValues: SocioeducationMeasureFamilyDataType = {
  id: null,
  descricaoRelacoesFamiliares: '',
  outrasReferenciasFamiliares: [],
  referenciasFamiliares: [],
}
